var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-avatar-placeholder",style:({ width: (_vm.size + "px"), height: (_vm.size + "px") })},[_c('img',{staticClass:"ui-avatar-placeholder__img",attrs:{"src":_vm.randomImage}})])}
var staticRenderFns = []

export { render, staticRenderFns }